import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import PoiCard from '../shared/PoiCard';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import moment from 'moment'

import find from 'lodash/find';
import truncate from 'lodash/truncate';

import './newscardsslider.scss';

class NewsCardsSlider extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.newsCategory != nextProps.newsCategory) {
      this.goToFirstCard();
    }
  }

  render() {

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    const placeholderCards = [<div key={0}><PoiCard/></div>, <div key={1}><PoiCard/></div>, <div key={2}><PoiCard/></div>, <div key={3}><PoiCard/></div>];

    const newsCards =  this.props.newsCategory.apiData.map((news, index) => {

      const { link, title, picture, content, publishDate, categories, tags, provider_name, provider_logo } = news

      const htmlText = (
        <div>
          <p>{truncate(content || '', { length: 100 })}</p>
          <p>
            <span>
              <strong>{provider_name || null}</strong>
            </span>
            {/* <br/>
            <span>
              {moment(publishDate).format("DD/MM/YYYY") || null}
            </span> */}
          </p>
        </div>
      );

      return (<div key={index}>
                <PoiCard title={title} 
                         htmlText={htmlText} 
                         buttonText={this.props.translate('news.news_cards_slider.read')} 
                         buttonLink={link} 
                         backgroundImage={picture}
                         gaEvent={{
                          category: 'MS-News',
                          value: link,
                          action: 'Categoria-news',
                          label: 'Categoria-news'
                        }}/>
              </div>)
    });

    return (
      <Row className="news-newscardsslider-component">
        <Col xs={12}>
          <div className="news-newscardsslider-component__title-wrap">
            <h4><strong>{this.props.translate('news.news_cards_slider.title')}</strong></h4>
            <h5>{this.props.translate('news.news_cards_slider.subtitle')}</h5>
          </div>

          <Well bsSize="large">
            <Slider ref={c => this.slider = c } {...slickSettings} className="news-newscardsslider-component__slider">
              { this.props.newsCategory.apiData.length > 0 ? newsCards : placeholderCards }
            </Slider>
            <p className="text-right"><small>powered by Microsoft News</small></p>
          </Well>
        </Col>
      </Row>
    );
  }
}

NewsCardsSlider.displayName = 'PagesNewsCardsSlider';
NewsCardsSlider.propTypes = {};
NewsCardsSlider.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    newsCategory: state.newsCategory
  };
};

export default connect(mapStateToProps)(NewsCardsSlider);



// WEBPACK FOOTER //
// ./components/pages/news/NewsCardsSlider.js